export default {
    titulo: "Suppliers",
    nuevo: "New Supplier",
    eliminar: "Delete Supplier",
    pregEliminar: "Are you sure you want to delete the supplier?",
    editar: "Edit Supplier",
    observaciones: "Observations"
}
